import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { GuiService } from 'src/app/services/gui.service';
import { RestService } from 'src/app/services/rest.service';
import { environment } from 'src/environments/environment';
import { WorkoutRestComponent } from './workout-rest/workout-rest.component';
import { WorkoutPhaseComponent } from './workout-phase/workout-phase.component';
import { ExerciseDetailComponent } from '../workout-detail/exercise-detail/exercise-detail.component';
import { RegisterWeightComponent } from './register-weight/register-weight.component';
import { LeaveWorkoutPopupComponent } from './leave-workout-popup/leave-workout-popup.component';
import { driver } from "driver.js";
import { WeightHistoryComponent } from './weight-history/weight-history.component';
import { SwapExerciseModalComponent } from '../workout-detail/swap-exercise-modal/swap-exercise-modal.component';

@Component({
  selector: 'vex-workout-execution',
  templateUrl: './workout-execution.component.html',
  styleUrls: ['./workout-execution.component.scss']
})
export class WorkoutExecutionComponent implements OnInit, OnDestroy {
  environment = environment.baseURL;
  workout: any;
  phaseNumber: number;
  exerciseNumber: number;
  setCounter: number;

  /* COUNTER INIZIALE DEL WORKOUT */
  workoutStartTimer: number = 5;
  startIntervalId: any;
  //
  /* GESTIONE TIMER ESERCIZIO A TEMPO */
  time: number = 0; // Tempo passato
  circumference: number = 2 * Math.PI * 36; // Lunghezza totale del cerchio
  offset: number = 0; // Offset per "riempire" il cerchio (inizialmente 0, parte pieno)
  private executiontimerInterval: any;
  isWorkoutPaused: boolean = false;
  remainingTime: number = 0;
  //
  eachSideView: number = 0;
  backLoader: boolean = false;
  isImageLoaded: boolean = true;
  isImageNextLoaded: boolean = true;

  constructor(public guiService: GuiService, public translate: TranslateService, private dialog: MatDialog, private restService: RestService, public router: Router, private activatedRoute: ActivatedRoute) { }

  ngOnInit()  {
    this.isImageLoaded = true;
    this.isImageNextLoaded = true;
    this.guiService.userLogged ? null : this.guiService.goTo('main/home');
    this.guiService.showSpinner = false;
    this.workout = JSON.parse(localStorage.getItem('workout'));
    console.debug(this.workout);
    this.activatedRoute.queryParams.subscribe(params => {
      if(params['exerciseNumber'] && params['setCounter'] && params['phaseNumber']){
        this.phaseNumber = parseInt(params['phaseNumber']);
        this.exerciseNumber = parseInt(params['exerciseNumber']);
        this.setCounter = parseInt(params['setCounter']);
        console.debug(this.phaseNumber ,this.exerciseNumber , this.setCounter)
      }else{
        this.phaseNumber = 0;
        this.exerciseNumber = 0;
        this.setCounter = 1;
      }
    });


    this.startTimer();
  }

  ngOnDestroy(): void {
    if (this.startIntervalId) {
      clearInterval(this.startIntervalId);
      this.startIntervalId = null;
    }

    if (this.executiontimerInterval) {
      clearInterval(this.executiontimerInterval);
      this.executiontimerInterval = null;
    }
  }

  startTimer(): void {
    if(this.workoutStartTimer < 5){
      this.workoutStartTimer = 5
      clearInterval(this.startIntervalId);
    }

    this.startIntervalId = setInterval(() => {
      if (this.workoutStartTimer > 0) {
        this.workoutStartTimer--;
        if(this.workoutStartTimer === 3){
          var sound = new Audio("../../../assets/sound/new-beep.mp3");
          sound.play();
        }
      } else {
        clearInterval(this.startIntervalId);
        console.debug('Timer start workout SCADUTO!');
        if (this.workout.phases[this.phaseNumber].exercises[this.exerciseNumber].executionTimeSeconds > 0){
          console.debug('AVVIATO PRIMO ESERCIZIO A TEMPO')
          this.executionTimer((this.workout.phases[this.phaseNumber].exercises[this.exerciseNumber].executionTimeSeconds));
        }

        localStorage.getItem('tourWorkoutExecutionShowed') ? null : this.startTour();
      }
    }, 1000);
  }

  skipStartTimer(){
    this.workoutStartTimer = 0;
    clearInterval(this.startIntervalId);
    console.debug('Timer start workout SKIPPATO!');
    if (this.workout.phases[this.phaseNumber].exercises[this.exerciseNumber].executionTimeSeconds > 0){
      console.debug('AVVIATO PRIMO ESERCIZIO A TEMPO')
      this.executionTimer((this.workout.phases[this.phaseNumber].exercises[this.exerciseNumber].executionTimeSeconds));
    }
    localStorage.getItem('tourWorkoutExecutionShowed') ? null : this.startTour();
  }

  executionTimer(maxTime: number) {
    this.clearExecutionTimer();
    this.executiontimerInterval = setInterval(() => {
      if(!this.isWorkoutPaused){
        this.time++;

      this.remainingTime = maxTime - this.time;
      const progress = (this.time / maxTime) * 100;
      this.offset = this.circumference - (progress / 100) * this.circumference;

      if (this.remainingTime === 3 && this.workout.phases[this.phaseNumber].exercises[this.exerciseNumber].eachSideFlag === false) {
        var sound = new Audio("../../../assets/sound/new-beep.mp3");
        sound.play();
      }

      if (this.time >= maxTime) {
        clearInterval(this.executiontimerInterval);
        const currentExercise = this.workout.phases[this.phaseNumber].exercises[this.exerciseNumber];
        if(currentExercise.eachSideFlag === false){
          console.debug('eachside FALSE')
          this.nextExercise();
        }else if(currentExercise.eachSideFlag === true && this.eachSideView === 0){
          this.playSingleBeep();
          this.eachSideView = 1;
          console.debug('eachside LATO SINISTRO!!!')
          this.executionTimer(currentExercise.executionTimeSeconds);
        }else if(this.eachSideView == 1){
          this.playSingleBeep();
          console.debug('eachside DESTRO SINISTRO!!!')
          this.eachSideView = 0
          this.nextExercise()
        }
      }
      }
    }, 1000);
  }

  playSingleBeep(){
    var sound = new Audio("../../../assets/sound/beep_single_new.mp3");
    sound.play();
  }

  clearExecutionTimer() {
    clearInterval(this.executiontimerInterval);
    this.time = 0;
    this.remainingTime = 0;
    this.offset = this.circumference; // Ripristina l'offset al valore iniziale (cerchio pieno)
    this.isWorkoutPaused = false;
  }

  pauseWorkout() {
    this.isWorkoutPaused = true;
  }

  resumeWorkout(){
    this.isWorkoutPaused = false;
  }

  workoutComplete(){
    console.debug('WORKOUT COMPLETED')
    const body = {
      userId: this.guiService?.userLogged?.user.id,
      currentProgram: this.guiService?.userLogged?.workoutInfo.currentProgram,
      day: localStorage.getItem('dayIndex'),
      week: this.guiService?.userLogged?.workoutInfo.programs[this.guiService?.userLogged?.workoutInfo.currentProgram].week,
      workoutId: this.workout._id,
      workoutStatus: 'COMPLETED',
      lastExerciseId: null,
      phaseNumber: null,
      setNumber: null
    };

    this.restService.postService('node', '/set-user-workout-info', body).subscribe((ris)=>{
      console.debug('SET WORKOUT INFO RESPONSE:', ris)
      this.guiService.userLogged.workoutInfo = ris;
    })

    this.router.navigate(['main/workout-completed'], {
      queryParams: { workoutTitle: this.workout.i18nName[this.translate.currentLang.toUpperCase()], workoutImageId: this.workout._id}
    });
  }

  getExercisObj(exercise){
    const resultExercise = this.workout.exerciseMap[exercise.exerciseId];
    resultExercise.repetitions = exercise.repetitions;
    resultExercise.executionTimeSeconds = exercise.executionTimeSeconds;
    return resultExercise
  }

  openModalRest(nextExercise: any, timer: any) {
  const dialogRef = this.dialog.open(WorkoutRestComponent, {
    data: {
      exercise: nextExercise,
      timer: timer
    },
    disableClose: true,
    width: '100vw',
    height: '100vh',
    maxWidth: '100vw',
    autoFocus: false,
    panelClass: 'full-screen-dialog'
  });

  dialogRef.afterClosed().subscribe((result) => {
    if (result !== null && result !== undefined) {
      console.log('Dati ricevuti dalla modale:', result);

      if (nextExercise.executionTimeSeconds > 0) {
        this.executionTimer(nextExercise.executionTimeSeconds);
      }
    }

    this.pauseWorkout();

    setTimeout(() => {
      this.resumeWorkout();
    }, 150);
  });
}

openModalPhase(phaseName: string, nextExercise: any, timer: any): void {
  const dialogRef = this.dialog.open(WorkoutPhaseComponent, {
    data: {
      phaseName,
      timer
    },
    disableClose: true,
    width: '100vw',
    height: '100vh',
    maxWidth: '100vw',
    autoFocus: false,
    panelClass: 'full-screen-dialog'
  });

  dialogRef.afterClosed().subscribe(() => {
    if (nextExercise.executionTimeSeconds > 0) {
      // SE IL PROSSIMO ESERCIZIO È A TEMPO, PARTI IL TIMER ALLA CHIUSURA DELLA MODALE
      this.executionTimer(nextExercise.executionTimeSeconds);
    }
    this.pauseWorkout();
    setTimeout(() => {
      this.resumeWorkout();
    }, 150);
  });
}

  nextExercise(){
    const currentPhase = this.workout.phases[this.phaseNumber];
    const currentExercise = currentPhase.exercises[this.exerciseNumber];
    const phasesLength = this.workout.phases.length-1;
    const lastExerciseInPhase = currentPhase.exercises.length-1;
    this.clearExecutionTimer();
    this.resumeWorkout();
    this.eachSideView = 0;
    this.isImageLoaded = false;
    this.isImageNextLoaded = false;

    if(phasesLength === this.phaseNumber){
      if((this.workout.phases[phasesLength].exercises.length-1) === this.exerciseNumber && this.setCounter === this.workout.phases[this.phaseNumber].repetitions){
        this.workoutComplete();
      }
    }
    if(this.exerciseNumber < lastExerciseInPhase){
      if(currentExercise.restTimeSeconds > 0){
        console.debug(currentExercise)
        const nextExercise = this.workout.phases[this.phaseNumber].exercises[this.exerciseNumber+1];
        this.updateNextAccorpedReps(nextExercise);
        setTimeout(() => {
          this.openModalRest(this.getExercisObj(nextExercise), currentExercise.restTimeSeconds);
        }, 100);
        /* SE IL PROSSIMO ESERCIZIO E' A TEMPO VIENE GESTITO ALLA CHIUSURA DELLA MODALE */
      }else{
        const nextExercise = this.workout.phases[this.phaseNumber].exercises[this.exerciseNumber+1];
        if(nextExercise.executionTimeSeconds > 0){
          /* SE IL PROSSIMO ESERCIZIO E' A TEMPO SE NON APRO LA MODALE FACCIO PARTIRE IL TIMER */
          this.executionTimer(nextExercise.executionTimeSeconds);
        }
      }

      this.exerciseNumber = this.exerciseNumber + 1; // AUMENTIAMO L'ESERCIZIO
      this.updateAccorpedReps();
    }else{
      if(this.phaseNumber < phasesLength && this.setCounter === currentPhase.repetitions){
        this.setCounter = 1; //I SETS SONO FINITI E RESETTO IL SET COUNTER A 1

        if(currentExercise.restTimeSeconds > 0){
          const nextExercise = this.workout.phases[this.phaseNumber+1].exercises[0];
          this.updateNextAccorpedReps(nextExercise);
          setTimeout(() => {
            this.openModalRest(this.getExercisObj(nextExercise), currentExercise.restTimeSeconds);
          }, 100);
          /* SE IL PROSSIMO ESERCIZIO E' A TEMPO VIENE GESTITO ALLA CHIUSURA DELLA MODALE */
        }else{
          const nextExercise = this.workout.phases[this.phaseNumber+1].exercises[0];
          //SE NON CE IL REST DELL'ESERCIZIO MOSTRO IL NEXT PHASE MODAL
          this.openModalPhase(this.workout.phases[this.phaseNumber+1].i18nName[this.translate.currentLang.toUpperCase()], nextExercise, 11);
        }

        this.phaseNumber = this.phaseNumber + 1; //AUMENTIAMO UNA FASE
        this.exerciseNumber = 0; // RIPORTIAMO L'ESERCIZIO AL PRIMO (0)
        this.updateAccorpedReps();

      }else if (this.exerciseNumber === lastExerciseInPhase && this.setCounter < currentPhase.repetitions){
        // E' FINITO UN SET
        if(currentPhase.restTimeSeconds > 0){
          const nextExercise = this.workout.phases[this.phaseNumber].exercises[0];
          this.updateNextAccorpedReps(nextExercise);
          setTimeout(() => {
            this.openModalRest(this.getExercisObj(nextExercise), currentPhase.restTimeSeconds);
          }, 100);
          /* SE IL PROSSIMO ESERCIZIO E' A TEMPO VIENE GESTITO ALLA CHIUSURA DELLA MODALE */
        }else{
          const nextExercise = this.workout.phases[this.phaseNumber].exercises[0];
          if(nextExercise.executionTimeSeconds > 0){
            /* SE IL PROSSIMO ESERCIZIO E' A TEMPO SE NON APRO LA MODALE FACCIO PARTIRE IL TIMER */
            this.executionTimer(nextExercise.executionTimeSeconds);
          }
        }

        this.exerciseNumber = 0; // RIPORTIAMO L'ESERCIZIO AL PRIMO (0)
        this.setCounter++ //AUMENTIAMO UN SET
        this.updateAccorpedReps();
      }
    }
  }

  previousExercise(){
    this.clearExecutionTimer();
    this.resumeWorkout();
    this.eachSideView = 0;
    this.isImageLoaded = false;
    this.isImageNextLoaded = false;

    if(this.exerciseNumber > 0){
      this.exerciseNumber = this.exerciseNumber - 1; // DIMINUIAMO L'ESERCIZIO
      const currentExercise = this.workout.phases[this.phaseNumber].exercises[this.exerciseNumber];
      if(currentExercise.executionTimeSeconds > 0){
        /* SE L'ESERCIZIO E' A TEMPO FACCIO PARTIRE IL TIMER */
        this.executionTimer(currentExercise.executionTimeSeconds);
      }
      this.updateAccorpedReps();
    }else if (this.exerciseNumber === 0 && this.setCounter === 1 && this.phaseNumber > 0){
      this.phaseNumber = this.phaseNumber - 1;

      const lastExerciseInPhase = this.workout.phases[this.phaseNumber].exercises.length-1;
      this.exerciseNumber = lastExerciseInPhase;
      const currentPhase = this.workout.phases[this.phaseNumber];
      this.setCounter = currentPhase.repetitions;

      const currentExercise = currentPhase.exercises[this.exerciseNumber];

      if(currentExercise.executionTimeSeconds > 0){
        /* SE L'ESERCIZIO E' A TEMPO FACCIO PARTIRE IL TIMER */
        this.executionTimer(currentExercise.executionTimeSeconds);
      }
      this.updateAccorpedReps();
    }
    else if (this.exerciseNumber === 0 && this.setCounter > 1){
      this.setCounter--;

      const lastExerciseInPhase = this.workout.phases[this.phaseNumber].exercises.length-1;
      this.exerciseNumber = lastExerciseInPhase;

      const currentPhase = this.workout.phases[this.phaseNumber];
      const currentExercise = currentPhase.exercises[this.exerciseNumber];
      if(currentExercise.executionTimeSeconds > 0){
        /* SE L'ESERCIZIO E' A TEMPO FACCIO PARTIRE IL TIMER */
        this.executionTimer(currentExercise.executionTimeSeconds);
      }
      this.updateAccorpedReps();
    }else {
      this.exerciseNumber--;
      this.updateAccorpedReps();
    }
  }

  openModalSwapExercise() {
    this.pauseWorkout();

    const exerciseId = this.workout.phases[this.phaseNumber].exercises[this.exerciseNumber].exerciseId;
    const exerciseAlternativeId = this.workout.exerciseMap[exerciseId]?.exerciseAlternativeId;

    const dialogRef = this.dialog.open(SwapExerciseModalComponent, {
      disableClose: true,
      panelClass: '',
      data: {
        exercise: this.workout.exerciseMap[exerciseId],
        exerciseAlternative: exerciseAlternativeId ? this.workout.exerciseMap[exerciseAlternativeId] : null
      },
      width: '600px'
    });

    dialogRef.afterClosed().subscribe(dataReturned => {
      this.resumeWorkout();

      if (dataReturned === 'confirm') {
        const currentExercise = this.workout.phases[this.phaseNumber].exercises[this.exerciseNumber];

        currentExercise.swapped = !currentExercise.swapped;
        currentExercise.exerciseId = exerciseAlternativeId;
        this.workout.exerciseMap[exerciseAlternativeId].exerciseAlternativeId = exerciseId;

        if (currentExercise.executionTimeSeconds > 0) {
          this.clearExecutionTimer();
        }
      }

      this.isImageLoaded = false;
      setTimeout(() => {
        this.isImageLoaded = true;
      }, 10);
    });
  }

  openModalExerciseDetail() {
  const exerciseId = this.workout.phases[this.phaseNumber].exercises[this.exerciseNumber].exerciseId;
  const equipConverted = [];

  if (this.workout.exerciseMap[exerciseId].equipmentIds && this.workout.exerciseMap[exerciseId].equipmentIds.length > 0) {
    this.workout.exerciseMap[exerciseId].equipmentIds.forEach(element => {
      equipConverted.push(this.workout.equipmentsMap[element]);
    });
  }

  this.pauseWorkout();

  const exerciseAlternativeId = this.workout.exerciseMap[exerciseId]?.exerciseAlternativeId;

  const dialogRef = this.dialog.open(ExerciseDetailComponent, {
    data: {
      exercise: this.workout.exerciseMap[exerciseId],
      equips: equipConverted.length > 0 ? equipConverted : null,
      isFromWorkoutExe: true,
      alternativeExercise: exerciseAlternativeId ? this.workout.exerciseMap[exerciseAlternativeId] : null
    },
    disableClose: true,
    autoFocus: false
  });

  dialogRef.afterClosed().subscribe((dataReturned) => {
    if (dataReturned === 'swap') {
      const currentExercise = this.workout.phases[this.phaseNumber].exercises[this.exerciseNumber];

      currentExercise.swapped = !currentExercise.swapped;
      currentExercise.exerciseId = exerciseAlternativeId;
      this.workout.exerciseMap[exerciseAlternativeId].exerciseAlternativeId = exerciseId;

      if (currentExercise.executionTimeSeconds > 0) {
        this.clearExecutionTimer();
        this.executionTimer(currentExercise.executionTimeSeconds);
      }
    }

    console.debug(dataReturned);
    this.resumeWorkout();
  });
}

  openModalRegisterWeight() {
  this.pauseWorkout();

  const dialogRef = this.dialog.open(RegisterWeightComponent, {
    disableClose: true,
    panelClass: 'register-weight-modal', // per la classe CSS personalizzata
    data: {} // se devi passare dati, inseriscili qui
  });

  dialogRef.afterClosed().subscribe(dataReturned => {
    this.resumeWorkout();

    if (dataReturned) {
      console.log('Dati ricevuti dalla modale:', dataReturned);
      if (dataReturned.weight && dataReturned.unit) {
        const param = {
          userId: this.guiService.userLogged.user.id,
          weight: dataReturned.weight,
          i18nNameWorkout: this.workout.i18nName,
          workoutId: this.workout._id,
          phaseName: this.workout.phases[this.phaseNumber].i18nName,
          unit: dataReturned.unit,
          sets: this.workout.phases[this.phaseNumber].repetitions,
          exerciseId: this.workout.phases[this.phaseNumber].exercises[this.exerciseNumber].exerciseId,
          exerciseName: this.workout.exerciseMap[this.workout.phases[this.phaseNumber].exercises[this.exerciseNumber].exerciseId].i18nName,
          reps: this.workout.phases[this.phaseNumber].exercises[this.exerciseNumber].repetitions,
          seconds: this.workout.phases[this.phaseNumber].exercises[this.exerciseNumber].executionTimeSeconds
        };

        this.restService.postService('node', '/workout-set-weight', param).subscribe(response => {
          // eventuale gestione risposta
        });
      }
       if(dataReturned && dataReturned === 'history'){
        console.debug('apro modale storico pesi');
        this.pauseWorkout();
        this.openModalWeightHistory(this.workout.phases[this.phaseNumber].exercises[this.exerciseNumber].exerciseId);
      }
    }
  });
}

  openModalWeightHistory(id: string) {
    const dialogRef = this.dialog.open(WeightHistoryComponent, {
      disableClose: true,
      width: '100vw',
      height: '100vh',
      maxWidth: '100vw',
      autoFocus: false,
      panelClass: 'full-screen-dialog',
      data: {
        exerciseId: id
      }
    });

    dialogRef.afterClosed().subscribe(dataReturned => {
      // Alla chiusura della modale storico, riapre quella per il peso
      this.openModalRegisterWeight();
    });
  }

  goBack(){
    const swappedExercises = {};
    this.workout.phases.forEach(phase => {
      phase.exercises.forEach(exercise => {
        if(exercise.swapped){
          swappedExercises[this.workout.exerciseMap[exercise.exerciseId].exerciseAlternativeId] =exercise.exerciseId;
        }
      });
    });
    const body = {
      userId: this.guiService?.userLogged?.user.id,
      currentProgram: this.guiService?.userLogged?.workoutInfo.currentProgram,
      day: localStorage.getItem('dayIndex'),
      week: this.guiService?.userLogged?.workoutInfo.programs[this.guiService?.userLogged?.workoutInfo.currentProgram].week,
      workoutId: this.workout._id,
      workoutStatus: 'PAUSED',
      lastExerciseId: this.workout.phases[this.phaseNumber].exercises[this.exerciseNumber].exerciseId,
      phaseNumber: this.phaseNumber ? this.phaseNumber : 0,
      setNumber: this.setCounter
    };
    Object.keys(swappedExercises).length === 0 ? null : body['swappedExercises'] = swappedExercises ;

    this.backLoader = true;
    this.restService.postService('node', '/set-user-workout-info', body).subscribe((ris)=>{
      console.debug('SET WORKOUT INFO RESPONSE:', ris)
      this.guiService.userLogged.workoutInfo = ris;
      this.backLoader = false;
      this.router.navigate(['main/workout-detail'], {
        queryParams: { id: this.workout._id , colorClass: localStorage.getItem('colorClass')}
      });
    })
  }

  canRegisterWeight(){
    const exercise = this.workout.exerciseMap[this.workout.phases[this.phaseNumber].exercises[this.exerciseNumber].exerciseId];

    if(exercise.equipmentIds){
      const tmp = [];
      exercise.equipmentIds.forEach(equipId => {
        tmp.push(this.workout.equipmentsMap[equipId].weight);
      });
      return tmp.includes(true);
    }
    return false
  }

  openModalStopWorkout(): void {
  this.pauseWorkout();

  const dialogRef = this.dialog.open(LeaveWorkoutPopupComponent, {
    disableClose: true,
    panelClass: 'register-weight-modal' // usa la stessa classe CSS personalizzata
  });

  dialogRef.afterClosed().subscribe(dataReturned => {
    console.log('Dati ricevuti dalla modale:', dataReturned);

    if (dataReturned === 'stop') {
      this.clearExecutionTimer();
      this.guiService.goTo('main/home');
    } else {
      this.resumeWorkout();
    }
  });
}

  nextExercisePreview(){
    const currentPhase = this.workout.phases[this.phaseNumber];
    const phasesLength = this.workout.phases.length-1;
    const lastExerciseInPhase = currentPhase.exercises.length-1;

    if(phasesLength === this.phaseNumber){
      if((this.workout.phases[phasesLength].exercises.length-1) === (this.exerciseNumber+1) && this.setCounter === this.workout.phases[this.phaseNumber].repetitions){
        return this.workout.phases[this.phaseNumber].exercises[this.exerciseNumber+1] ? this.workout.phases[this.phaseNumber].exercises[this.exerciseNumber+1] : null
      }else{
        return this.workout.phases[this.phaseNumber].exercises[this.exerciseNumber+1]
      }
    }

    if(this.exerciseNumber < lastExerciseInPhase){
      return this.workout.phases[this.phaseNumber].exercises[this.exerciseNumber+1];
    }else{
      if(this.phaseNumber < phasesLength && this.setCounter === currentPhase.repetitions){
        return this.workout.phases[this.phaseNumber+1].exercises[0];
      }else if (this.exerciseNumber === lastExerciseInPhase && this.setCounter < currentPhase.repetitions){
        return this.workout.phases[this.phaseNumber].exercises[0];
      }
    }
  }

  updateAccorpedReps() {
    const exercise = this.workout.phases[this.phaseNumber].exercises[this.exerciseNumber];
    if (exercise.accorped) {
      const newReps = exercise.arrRepetitions[this.setCounter - 1];
      if (newReps !== undefined) {
        exercise.repetitions = newReps;
      }
    }
  }

  updateNextAccorpedReps(exercise) {
    if (exercise.accorped) {
      const newReps = exercise.arrRepetitions[this.setCounter - 1];
      if (newReps !== undefined) {
        exercise.repetitions = newReps;
      }
    }
  }

  getPhaseDescription(desc: any) {
    if (desc) {
      const description = JSON.parse(desc);
      if (description[this.translate.currentLang.toUpperCase()]) {
        return description[this.translate.currentLang.toUpperCase()]
      }
      return false
    }
    return false
  }

  startTour(): void {
    localStorage.setItem('tourWorkoutExecutionShowed', 'true');
    setTimeout(() => {
      this.pauseWorkout();
    }, 1050);

    const thirdStepClass = this.workout.phases[this.phaseNumber].exercises[this.exerciseNumber].executionTimeSeconds > 0 ? '.rem-timer-tutorial' : '.reps-number';

    const driverObj = driver({
      showProgress: true,
      allowClose: true,
      steps: [
        { element: '.phase-title', popover: { title: this.translate.instant('TUTORIALS.workout-execution.phaseSeriesTitle'), description: this.translate.instant('TUTORIALS.workout-execution.phaseSeriesDescription'), side: 'bottom' } },
        { element: '.img-exercise', popover: { title: this.translate.instant('TUTORIALS.workout-execution.exerciseVideoTitle'), description: this.translate.instant('TUTORIALS.workout-execution.exerciseVideoDescription'), side: 'bottom'  } },
        { element: thirdStepClass , popover: { title: this.translate.instant('TUTORIALS.workout-execution.repsCountTitle'), description: this.translate.instant('TUTORIALS.workout-execution.repsCountDescription') } },
        { element: '.back-btn-workout-exe-tutorial' , popover: { title: this.translate.instant('TUTORIALS.workout-execution.backWorkoutTitle'), description: this.translate.instant('TUTORIALS.workout-execution.backWorkoutDescription') } },
        { element: '.pause-btn', popover: { title: this.translate.instant('TUTORIALS.workout-execution.pauseTitle'), description: this.translate.instant('TUTORIALS.workout-execution.pauseDescription') } },
      ],
      onDestroyed: () => {
        console.log('Tutorial chiuso o terminato');
        this.resumeWorkout();
      }
    });

    driverObj.drive();
  }

  onImageLoad(){
    this.isImageLoaded = false;
    setTimeout(() => {
      this.isImageLoaded = true;
      console.log('✅ Immagine caricata con successo');
    }, 250);
  }

  onImageNextLoad(){
    this.isImageNextLoaded = false;
    setTimeout(() => {
      this.isImageNextLoaded = true;
      console.log('✅ Immagine Next caricata con successo');
    }, 250);
  }

}
